/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface CompanyItem { 
    publicUrl?: string;
    originalName?: string;
    name?: string;
    oib?: string;
    address?: string;
    representative?: string;
    city?: string;
    postalCode?: string;
    representativeFirstName?: string;
    representativeLastName?: string;
    streetAddress?: string;
}

